<template>
<tbody class="table-font" style="font-size:13px;" v-if="item!=null">
    <tr :style="item.isfake==1?'color:red':''">
        <td>{{index+1}}</td>
        <!-- <td>{{item.customer?.generatedid}}</td> -->
        <td>{{item.customername}}</td>
        <td>{{item.customermobile}}</td>
        <td>{{item.alternatemobile}}</td>
        <td>{{item.customeraddress}}</td> 
        <td>{{item.refrence}}</td>
        <!-- <td>{{item.complaintno}}</td>  -->
        <td>{{item.remark}}</td>
        
        <!-- <td style="font-size:10px ;">
            <div>
                <div>
                    <span v-if="item.product!=null && item.product.category!=null">{{item.product.category.name}}</span>
                    <span v-if="item.product!=null && item.product.attribute!=null">
                        <div v-for="company in item.product.attribute" :key="company.id">
                            {{ getcompany(company.attribute_value_ids) }}
                        </div>
                    </span>
                    <span >{{item.product.name}}</span>&nbsp;
                </div>
            </div>
        </td> -->
        <!-- <td>{{item.scheduledate!=null?moment(item.scheduledate).format('DD-MM-YYYY'):"N.A"}}</td> -->
        <td><span v-if="item.enteredby!=null">{{item.enteredby.name}}<br>
            {{moment(item.created_at).format('DD-MM-YYYY')}}</span>
        </td>
        <!-- <td><span :style="item.status==0?'color:red':'color:green'">{{ item.status==0?'Pending':'Resolved'}}</span></td> -->
        <td @dblclick="showfiled=!showfiled" @keyup.enter="showfiled=!showfiled">
            <span v-if="item.followby!=null">{{item.followby.name}}</span>
            <select v-if="showfiled" v-model="followedid" class="form-control form-cascade-control input-small" @change="showfollowedfield(item)">
                <option v-for="filter in employees" :key="filter.id" :value="filter.id" ><span >{{filter.name}}<br>{{filter.generatedid}}</span></option>
            </select> 
        </td>
        <td><span style="background-color: #b4e887;border: 1px solid;padding:2px;">{{item.ratings}}  </span> 
            <span v-for="item in item.ratings" :key="item">
                <i class='bx bxs-star' style='color:#f5ea07'></i>
            </span>
        </td>
        <td v-if="loginusercheck(193)"> <button class="badge btn-prime btn-xs" @click="showchats()" >conversation</button></td>
        <td> 
            <button class="badge btn-danger btn-xs" v-if="item.isfake==1" @click="updatefakemodal(item)" >Fake</button>
            <button class="badge btn-success btn-xs" v-if="item.isfake==0" @click="updatefakemodal(item)" >Relevant</button>
        </td>
        <td> <button class="badge btn-prime btn-xs" @click="edit(item)" >Edit</button></td>
        <td @dblclick="leadnatureupdate(item)" @keyup.enter="leadnatureupdate(item)">
            <select v-if="naturetypefield" class="form-control form-cascade-control input-small" v-model="item.naturetype" @change="leadnatureupdate(item)">
                <option :value="0">SELECT</option>
                <option :value="1">HOT</option>
                <option :value="2">COLD</option>
                <option :value="3">WARM</option>
            </select>
            {{ leadnaturetype(item.naturetype) }}
        </td>
    </tr>
    <tr v-if="visitcomments">
        <td colspan="14">
            <customer-conversation :item="item" :show="true"></customer-conversation>
        </td>
    </tr>
</tbody>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import CustomerConversation from '../leads/CustomerConversation.vue'
import Constants from '../../components/utilities/Constants.vue'
export default {
    props:['item','index'],
    components:{CustomerConversation},
    mixins:[Constants],
    data() {
        return {
            moment:moment,
            visitcomments:false,
            followedid:0,
            showfiled:false,
            naturetypefield:false
        }
    },
    computed:{
        ...mapGetters(['employees','loggedinuser','attributes'])
    },
    mounted() {
        if(this.item.followby!=null){
            this.followedid=this.item.followby.id
        }
        this.$store.dispatch('fetchemployees')
    },
    methods: {
        showchats(){
            this.visitcomments=!this.visitcomments
        },
        requestmethod(item){
            let type="";
            switch (item.requesttype) {
                case 1:
                    type= "QUERY";
                    break;
                case 2:
                    type= "Complaint";
                    break;
                case 3:
                    type= "Feedback";
                    break;
                case 4:
                    type= "ORDER";
                    break;
                default:
                    break;
            }
            return type;
        },
        
        refresh(){
            this.$parent.refresh()
        },
        // updatefield(){

        // },
        showfollowedfield(item){
            if(this.loginusercheck(170)){
                this.showfiled=!this.showfiled
                let param={id:item.id,column:"followedid",value:this.followedid}
                this.$http.post('api/leads/updatefield',param)
                    .then((response) =>this.processUpdateResponse(response.data))
                    .catch((err) => {
                        this.errorShow(err)
                    });
            }else{
                alert('You Dont have Right')
            }
        },
        processUpdateResponse(data){
            // this.showfiled=false
            this.$parent.refresh()
            this.$notify({
                text:'Field Updated Successfully',data,
                type:'success',
                duration:'-1',
                speed:'100',
                closeOnClick:false
            })
        },
        errorShow(){
            this.$store.commit('assignloadingstatus',0)
            alert("Something went wrong, please try after sometime.")
        },
        getcompany(attribute_value_ids) {
            let brand = this.attributes.find((block) => block.id == +2);
            if (typeof brand !== "undefined") {
                let companyname = brand.predefinedvalues.find(
                (a) => a.id == attribute_value_ids
                );
                if (typeof companyname != "undefined") {
                return companyname.value;
                }
            }
            return attribute_value_ids;
        },
        edit(item){
            this.$store.commit('assignleadsedit',item)
            this.$store.commit('assignviewno',2)
        },
        updatefakemodal(item){
            this.$store.commit('assignedititem',item)
            this.$modal.show('leadfakemodal')
        },
        leadnatureupdate(item){
            this.naturetypefield=!this.naturetypefield
            if(confirm("Do you want to update nature of lead")){

                let param={id:item.id,column:"naturetype",value:item.naturetype}
                this.$http.post('api/leads/updatefield',param)
                .then((response) => this.processnatureUpdateResponse(response.data))
                .catch((err) => {
                    console.log('', err)
                });            
            }
            
        },
        processnatureUpdateResponse(){
            this.$notify({
                text: 'Details Saved Successfully',
                type: 'success',
                duration: '-1',
                speed: '100',
                closeOnClick: false
            })
            this.$parent.refresh();
        },
    },
}
</script>